import { render, staticRenderFns } from "./EventEditDialog.vue?vue&type=template&id=fcdc47fa&"
import script from "./EventEditDialog.vue?vue&type=script&lang=js&"
export * from "./EventEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports